import { Card, Result } from "antd";
import { FormConfig } from "../../App";

// Simple HTML sanitizer - strips script tags and event handlers
const sanitizeHtml = (html: string): string => {
  return html
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/\bon\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*)/gi, '')
    .replace(/javascript\s*:/gi, '');
};

interface SuccessPageProps {
  formConfig: FormConfig | null;
}

const SuccessPage = ({ formConfig }: SuccessPageProps) => {
  const title = formConfig?.success_title || "Jūsų užsakymas gautas sėkmingai";
  const message =
    formConfig?.success_message ||
    "Mes gavome jūsų registraciją, artimiausiu metu gausite el. laišką su papildoma informacija.";

  return (
    <Card
      style={{
        minHeight: "400px",
        background: "#F6F6F6",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      {formConfig?.success_message ? (
        <Result
          status="success"
          title={title}
          subTitle={
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(message) }} />
          }
        />
      ) : (
        <Result status="success" title={title} subTitle={message} />
      )}
    </Card>
  );
};

export default SuccessPage;
